import React from 'react';
import { Footer, Input } from 'components/layout';
import { useForm, FormProvider } from 'react-hook-form';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { cyberpunk, night, ocean } from 'assets/colors';
import packageJson from '../../../package.json';
import { useStyle } from './styles';
import { loginPolicies } from 'helpers';
import LineDraw from './LineDraw';
import Cube from './Cube';
import {
  CircularProgress,
  Backdrop,
  Box,
  Grid,
  Typography,
  Button,
  Paper
} from '@mui/material';
import { Logo, LanguageButton } from 'components/common';


const CubesAnimation = ({ handleLogin, isLoaded, handleOnSubmit }) => {
  const [t] = useTranslation();
  const methods = useForm({ defaultValues: { username: '', password: '', rememberMe: false } });
  const classes = useStyle();
  const { handleSubmit, reset, control, setValue } = methods;


  const fields = [
    { policy: loginPolicies.username },
    { policy: loginPolicies.password },
    { policy: loginPolicies.rememberMe }
  ];

  const size = 100

  return (
    <div className={classes.cubesAnimation}>


      <div sx={classes.rowCubes}>
        <Cube className={classes.cube} primaryColor={ocean[500]}/>
        <Cube className={classes.cubeSide} primaryColor={ocean[500]}/>
        <Cube className={classes.cubeLast} primaryColor={ocean[500]}/>
      </div>


    </div>
  );
}

export default CubesAnimation;
